import React from "react";
import Dashboard2 from "./dashboard2";
import TopNav from "./container/TopNav";

function App() {
  return (
    <div>
      <TopNav />
      <Dashboard2 />
    </div>
  );
}

export default App;
